import {Garage} from "@App/types";

export const useContext = () => {

    //regular expression that matches uuid
    const uuidRegularExpression = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;


    const getContext = (garage: Garage) => {
        const requestId = window.sessionStorage.getItem(`correlationID${garage.id}`);
        const headers = {}

        //if the requestId is a valid UUID add the header
        uuidRegularExpression.test(requestId) ? headers["X-Repareo-RequestId"] = requestId : '';

        return {headers}
    }

    return {
        getContext
    }
}
